import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Tabs, Tab } from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views';
import { UserPermissions } from '../../utils/UserPermissions';
import { PageWrapperHeight } from '../../utils/LayoutSizes';
import RedirectToLogin from '../../utils/RedirectToLogin';
import { getCurrentUser } from '../../services/authService';
import PositionsPayRate from './PositionsPayRate/PositionsPayRate';
import StaffPayRate from './StaffPayRate/StaffPayRate';
import RaisePayRate from './RaisePayRate/RaisePayRate';
import './PayRates.scss';

export const SwipeableViewsContext = React.createContext();
export const PayRatesContext = React.createContext();

function PayRates(props) {
  const [tabIndex, setTabIndex] = useState(0)
  const [tabsContent, setTabsContent] = useState([]);
  const [swipeableActions, setSwipeableActions] = useState(null);
  const [pageWrapperHeight, setPageWrapperHeight] = useState(0);

  const PositionsPayRatesContent = {
    label: 'Rate Ranges',
    content: idx => (
      <PositionsPayRate key={idx} />
    )
  }

  const StaffPayRatesContent = {
    label: 'Rates by Staff',
    content: idx => (
      <StaffPayRate key={idx} />
    )
  }

  const IncreasePayRatesContent = {
    label: 'Increase Rates',
    content: idx => (
      <RaisePayRate key={idx} />
    )
  }

  const tabContentBuilder = () => {
    let tabContentBuild = [];
    UserPermissions('module_pay_rates_tab_positions') && tabContentBuild.push(PositionsPayRatesContent);
    UserPermissions('module_pay_rates_tab_staff') && tabContentBuild.push(StaffPayRatesContent);
    UserPermissions('module_pay_rates_tab_increase') && tabContentBuild.push(IncreasePayRatesContent);
    setTabsContent(tabContentBuild);
  };

  const updateSwipeableHeight = () => {
    swipeableActions && swipeableActions.updateHeight();
  }

  useEffect(() => {
    setPageWrapperHeight(PageWrapperHeight());
    tabContentBuilder();
  }, []);

  useLayoutEffect(() => {
    const handleResize = () => {
      setPageWrapperHeight(PageWrapperHeight());
    };
    window.addEventListener('resize', handleResize)

    return _ => {
      window.removeEventListener('resize', handleResize)
    }
  });

  return (
    !getCurrentUser()
      ? <RedirectToLogin location={props.location} />
      : <SwipeableViewsContext.Provider value={{ updateSwipeableHeight }}>
          <PayRatesContext.Provider value={{ props }}>
            <main className="PayRatesPage page-wrapper container-fluid" style={{minHeight: pageWrapperHeight + "px"}}>
              <section className="page-header">
                <div className="row">
                  <div className="col">
                    <h1 className="page-title"><i aria-hidden="true" className="fas fa-solid fa-cash-register"></i>&nbsp;Pay Rates</h1>
                  </div>
                </div>
              </section>
              <section className="page-body">
                <Tabs
                  value={tabIndex}
                  onChange={(e, value) => setTabIndex(value)}
                  classes={{ root: 'cms-tabs', indicator: 'cms-tabs-indicator' }}
                >
                  {tabsContent.map((form, idx) => (
                    <Tab key={idx} label={form.label} classes={{ root: 'cms-tab', selected: 'cms-tab-selected' }} />
                  ))}
                </Tabs>
                <SwipeableViews
                  index={tabIndex}
                  onChangeIndex={tabIndex => setTabIndex(tabIndex)}
                  animateHeight={true}
                  disableLazyLoading={true}
                  animateTransitions={true}
                  action={actions => {
                    setSwipeableActions(actions);
                  }} >
                  {tabsContent.map((form, idx) => (
                    form.content(idx)
                  ))}
                </SwipeableViews>
              </section>
            </main>
          </PayRatesContext.Provider>
        </SwipeableViewsContext.Provider>
  )
}

export default PayRates
